<app-dc-pane>
    <ng-container class="heading">
        {{ test?.name }}
    </ng-container>
    <app-dc-table
        *ngFor="let result of test?.testResult"
        [messages]="messages"
        [rows]="result"
        [showFooter]="false"
        [columns]="columns">
    </app-dc-table>
</app-dc-pane>